import React, { useState } from "react";
import Popup from "../popup/Popup";
import { POPUP_FORM_CONTENT_CLASS, ACTION_POPUP_CONTENT_INNER_CLASS } from "../popup/popupLayoutSpec";
import Title from "../common/Title/Title";
import { AccountPopupSaveFooter } from "../BusinessDashboard/accountPopupFields";
import { AdminPageTitle } from "../../sections/AdminDashboard/shared/adminUx";
import { validateFile, getAcceptAttribute } from "../../utils/contentSafety";
import Alerts from "../common/Alerts/Alerts";

const ProfileImagePopup = ({ isOpen, onClose, onCompletionUpdate }) => {
  const [profilePictureUploaded, setProfilePictureUploaded] = useState(null);

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const result = validateFile(file, "image");
    if (!result.valid) {
      Alerts.error(result.message);
      e.target.value = "";
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      setProfilePictureUploaded(reader.result);
    };
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  const handleSave = () => {
    if (profilePictureUploaded && onCompletionUpdate) {
      onCompletionUpdate("profilePicture", profilePictureUploaded);
    }
    onClose();
  };

  if (!isOpen) return null;

  return (
    <Popup
      setTrigger={() => {}}
      ShowCrossButton={true}
      cross={true}
      onClose={onClose}
      businessDashboard={true}
      hideLogoInHeader={true}
    >
      <div
        className="overflow-auto relative flex items-center justify-center"
        style={{ minHeight: "calc(100vh - 120px)" }}
      >
        <div className={POPUP_FORM_CONTENT_CLASS}>
          <div className={ACTION_POPUP_CONTENT_INNER_CLASS}>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="mb-4 text-center">
                <AdminPageTitle className="text-center pb-0 text-offblack mb-10">
                  Profile Picture Upload
                </AdminPageTitle>
              </div>
              <div className="flex justify-center w-full">
                <div className="relative size-[192px] mx-auto">
                  <div
                    className={`size-[192px] rounded-full ${
                      profilePictureUploaded ? "" : "border border-solid border-mediumgray"
                    }`}
                  >
                    {profilePictureUploaded ? (
                      <img
                        className="object-center rounded-full w-full h-full cursor-pointer"
                        src={profilePictureUploaded}
                        alt="Profile"
                      />
                    ) : (
                      <div className="object-center rounded-full w-full h-full cursor-pointer bg-white" />
                    )}
                  </div>
                  <div className="absolute z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    <div
                      className={`flex justify-center items-center rounded-full size-[30px] pt-[2px] relative ${
                        profilePictureUploaded ? "bg-white" : ""
                      }`}
                    >
                      <label role="button" className="flex justify-center bg-transparent cursor-pointer">
                        <input
                          type="file"
                          accept={getAcceptAttribute("image")}
                          onChange={handleFileInputChange}
                          className="hidden"
                        />
                        {!profilePictureUploaded ? (
                          <Title text="Upload" width="50">
                            <i className="fi fi-rs-upload text-base text-offblack" />
                          </Title>
                        ) : (
                          <Title text="Edit" width="50">
                            <i className="fi fi-rr-pencil text-base text-offblack" />
                          </Title>
                        )}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {profilePictureUploaded && (
                <AccountPopupSaveFooter onClick={handleSave} label="Save" />
              )}
            </form>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default ProfileImagePopup;
